<template>
  <div class="module-properties">
    <div class="form-group">
      <label>Formato de Exportação</label>
      <select v-model="config.exportFormat">
        <option value="csv">CSV</option>
        <option value="json">JSON</option>
        <option value="excel">Excel</option>
        <option value="parquet">Parquet</option>
        <option value="database">Banco de Dados</option>
      </select>
    </div>
    
    <div class="form-group" v-if="config.exportFormat === 'database'">
      <label>Tipo de Banco</label>
      <select v-model="config.dbType">
        <option value="postgres">PostgreSQL</option>
        <option value="mysql">MySQL</option>
        <option value="sqlserver">SQL Server</option>
        <option value="oracle">Oracle</option>
      </select>
    </div>
    
    <div class="form-group" v-if="config.exportFormat === 'database'">
      <label>Nome da Tabela</label>
      <input type="text" v-model="config.tableName" placeholder="Nome da tabela de destino">
    </div>
    
    <div class="form-group" v-if="config.exportFormat !== 'database'">
      <label>Caminho de Destino</label>
      <input type="text" v-model="config.outputPath" placeholder="Caminho para salvar o arquivo">
    </div>
    
    <div class="form-group">
      <label>Incluir Cabeçalho</label>
      <input type="checkbox" v-model="config.includeHeader">
    </div>
    
    <div class="form-group">
      <label>Compressão</label>
      <select v-model="config.compression">
        <option value="none">Nenhuma</option>
        <option value="gzip">GZIP</option>
        <option value="zip">ZIP</option>
      </select>
    </div>
    
    <div class="form-group">
      <label>Modo de Escrita</label>
      <select v-model="config.writeMode">
        <option value="overwrite">Sobrescrever</option>
        <option value="append">Anexar</option>
        <option value="error">Erro se existir</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExportModuleProperties',
  props: {
    module: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      config: {
        exportFormat: 'csv',
        dbType: 'postgres',
        tableName: '',
        outputPath: '',
        includeHeader: true,
        compression: 'none',
        writeMode: 'overwrite',
        ...this.module.config
      }
    };
  },
  watch: {
    config: {
      handler(newConfig) {
        this.$emit('update:config', newConfig);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.module-properties {
  padding: 10px;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
select, input[type="text"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
